import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { faqItems } from "@/data/eventOrganizerContent";

const FAQSection = () => {
  return (
    <section id="faq" data-testid="faq-section" className="space-y-10 py-24">
      <div className="max-w-3xl space-y-4">
        <p
          data-testid="faq-eyebrow-text"
          className="inline-flex rounded-full border border-fuchsia-200 bg-fuchsia-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.16em] text-fuchsia-700"
        >
          Frequently Asked Questions
        </p>
        <h2 data-testid="faq-heading" className="text-3xl leading-tight text-violet-950 md:text-5xl">
          Clear answers before we start planning your event.
        </h2>
      </div>

      <Accordion type="single" collapsible className="rounded-2xl border border-fuchsia-200 bg-violet-50/75 px-6" data-testid="faq-accordion">
        {faqItems.map((item, index) => (
          <AccordionItem value={`item-${index}`} key={item.question} data-testid={`faq-item-${index + 1}`}>
            <AccordionTrigger
              data-testid={`faq-question-${index + 1}`}
              aria-label={`Toggle answer for ${item.question}`}
              className="py-6 text-left text-base text-violet-900 hover:no-underline"
            >
              {item.question}
            </AccordionTrigger>
            <AccordionContent data-testid={`faq-answer-${index + 1}`} className="text-sm leading-relaxed text-stone-600 md:text-base">
              {item.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
};

export default FAQSection;